/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// Formik and Yup
import { Field, FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Backdrop from "@mui/material/Backdrop";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import TextError from "utils/TextError";
// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

//  some date function
import { addMinutes, format } from "date-fns";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CancelIcon from "@mui/icons-material/Clear";
// Functions from store
import {
  createDynamicColumn,
  createTransferOrderForQtyW2,
  createTransferOrderW2,
  getAllTransferOrders,
  getAvailableQtyForTo,
  getCreatedActivity,
  getDocumentType,
  getDynamicColumn,
  getItemMaster,
  getLevel1ByLevelForTransferOrder,
  getLevel1ByLevelSrc,
  getLevel2ByLevelForTransferOrder,
  getLevel2ByLevelSrc,
  getLevel3ByLevelForTransferOrder,
  getLevel3ByLevelSrc,
  getLevel4ByLevelForTransferOrder,
  getLevel4ByLevelSrc,
  getLevelsByWarehouse,
  getRelationLocation,
  getSubModulesByRoleId,
  getSuids,
  getTransferOrderDownloads,
  getWarehousesByItemCodeAndMovement,
  reprint,
  splitQty,
} from "../../../store";

// config file
import Config from "../../../config/index";

// Cookies
import CreateButton from "components/standardized-components/CreateButton";
import ViewButton from "components/standardized-components/ViewButton";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 380, sm: 380, md: 800, lg: 1200, xl: 1200 },
  overflow: "auto",
  height: "80%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};
const styleForCreate = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 380, md: 800, lg: 1500, xl: 1500 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
  overflow: "scroll",
};
const styleForCategoryModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 380, sm: 480, md: 800, lg: 1200, xl: 1200 },
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const TransferOrderW2 = ({
  getAllTransferOrders,
  getTransferOrderDownloads,
  transferOrders,
  createTransferOrderW2,
  createTransferOrderForQtyW2,
  getItemMaster,
  itemMaster,
  getDocumentType,
  getCreatedActivity,
  getCreatedActivityReducer,
  getDocumentTypeReducer,
  getSuids,
  getSuidsReducer,
  getWarehousesByItemCodeAndMovement,
  getWarehouseByItemCodeAndMovementReducer,
  getLevel1ByLevelForTransferOrder,
  getLevel2ByLevelForTransferOrder,
  getLevel3ByLevelForTransferOrder,
  getLevel1ByLevelForTransferOrderReducer,
  getLevel2ByLevelForTransferOrderReducer,
  getLevel3ByLevelForTransferOrderReducer,
  getLevel4ByLevelForTransferOrder,
  getAllTransferOrdersDownloadReducer,
  getLevel4ByLevelForTransferOrderReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getAvailableQtyForTo,
  availableQtyState,
  getLevel1ByLevelSrc,
  getLevel2ByLevelSrc,
  getLevel3ByLevelSrc,
  getLevel4ByLevelSrc,
  getRelationLocation,
  level1ByLevelSrcReducer,
  level2ByLevelSrcReducer,
  level3ByLevelSrcReducer,
  level4ByLevelSrcReducer,
  getRelationLocationReducer,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,
  getDynamicColumn,
  getDynamicColumnReducer,
  createDynamicColumn,
  splitQty,
  splitQtyReducer,
  reprint,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let printerConfig = cookies.get("printerConfigForWarehouse");
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  // let printerId = loginDetails.data.printerId;

  let printerId = cookies.get("printerIdForWarehouse");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  const [dZoneSelected, setDzoneSelected] = useState("");

  const [dRackSelected, setDrackSelected] = useState("");

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "b4118841-208a-4dd4-8f2e-fdf47adc851c";

  let TransferOrderModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "b4118841-208a-4dd4-8f2e-fdf47adc851c",
  );

  let createNewTransferOrder = TransferOrderModule
    ? TransferOrderModule.actionId.includes(
        "b4d79d57-9586-4453-93a0-dd8f2b196ef6",
      )
    : null;

  // let viewTransferOrder = TransferOrderModule
  //   ? TransferOrderModule.actionId.includes(
  //       "aa38bfe6-15d6-464c-b64b-d2eeee32647d"
  //     )
  //   : null;

  let viewTransferOrder = false;
  let viewSuids = TransferOrderModule
    ? TransferOrderModule.actionId.includes(
        "63bdb930-f7c0-4828-b7e4-d35df4e59dc0",
      )
    : null;
  let downloadAccess = TransferOrderModule
    ? TransferOrderModule.actionId.includes(
        "e5c6da36-4cd8-437b-9f6b-68e3a4093859",
      )
    : null;

  let splitSuidAccess = TransferOrderModule
    ? TransferOrderModule.actionId.includes(
        "f0aad159-1087-4e1b-bff1-dec934d49cc3",
      )
    : null;

  let autoPopulateLocationAccess = TransferOrderModule
    ? TransferOrderModule.actionId.includes("")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  setTimeout(() => {
    setRefresh(!refresh);
  }, 60000);

  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");
  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");

  const [selectedItemCode, setSelectedItemCode] = useState("");

  useEffect(() => {
    getRelationLocation(jwtToken);
  }, []);

  const data = getRelationLocationReducer.locations?.data || [];
  useEffect(() => {
    viewTransferOrder &&
      getAllTransferOrders(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewTransferOrder, pageNo, rowsPerPage, searchObject, refresh]);

  const [dWarehouseSelected, setDwarehouseSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");
  const [sSectionSelected, setSsectionSelected] = useState("");
  useEffect(() => {
    getTransferOrderDownloads(searchObject, jwtToken);
  }, [searchObject]);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    getSuids(
      selectedItemCode ? selectedItemCode?.itemId : "",
      activityIdSelected?.mvtId,
      debouncedSearchTerm,
      jwtToken,
    );
  }, [selectedItemCode, activityIdSelected, debouncedSearchTerm]);

  const [dSectionSelected, setDsectionSelected] = useState("");

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Created",
      value: 0,
    },
    {
      label: "Closed",
      value: 1,
    },
  ];

  const [state, setState] = useState({
    columns: [
      {
        Header: "Transfer Order No",
        accessor: "documentNumber",
        align: "left",
      },
      { Header: "Item Code", accessor: "itemCode", align: "left" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      {
        Header: "SUID",
        accessor: "suid",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
      { Header: "Source Location", accessor: "source", align: "left" },
      { Header: "Delivery Location", accessor: "destination", align: "left" },
      { Header: "Qty", accessor: "qty", align: "left" },
      { Header: "Uom", accessor: "uom", align: "left" },

      {
        Header: "Status",
        accessor: "status",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [categoryItemTable, setCategoryItemTable] = useState({
    columns: [
      { Header: "Suid", accessor: "suid", align: "left" },
      { Header: "LOT No", accessor: "lotNumber" },
      { Header: "Serial No", accessor: "serialNumber" },
      { Header: "Qty", accessor: "qty", align: "left" },
      // { Header: "Created Date", accessor: "createdDate", align: "left" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns: categoryColumns, rows: categoryRows } = categoryItemTable;

  const [categoryItems, setCategoryItems] = useState("");

  useEffect(() => {
    let tempCategoryItemsObj = [];

    let data = categoryItems ? categoryItems : [];

    data.map((data) => {
      const formatDate = new Date(data.cd);
      const categoryItemsObj = {
        suid: data.suid,
        qty: data.qty,
        lotSerialNo: `${data.lotNumber ? data.lotNumber : "NA"} / ${
          data.serialNumber ? data.serialNumber : "NA"
        }`,
        lotNumber: `${data.lotNumber ? data.lotNumber : "NA"}`,
        serialNumber: `${data.serialNumber ? data.serialNumber : "NA"}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: data.cd,
      };

      tempCategoryItemsObj.push(categoryItemsObj);
    });

    setCategoryItemTable({ ...categoryItemTable, rows: tempCategoryItemsObj });
  }, [categoryItems]);
  const [openCategoryLineItemsModal, setOpenCategoryLineItemsModal] =
    useState(false);

  const handleOpenCategoryLineItemsModal = () => {
    setOpenCategoryLineItemsModal(true);
  };

  const handleCloseCategoryLineItemsModal = () => {
    setOpenCategoryLineItemsModal(false);
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempTransferOrders = [];
    let data = transferOrders.transferOrders.data || []; // Safe fallback
    setPaginationObj(transferOrders?.transferOrders?.pagination);
    setLoading(transferOrders.loading);

    // Loop through transfer orders
    data.forEach((to) => {
      const formatDate = new Date(to.cd);
      let des = to?.itemDescription;
      const len = desLength; // Assuming desLength is defined elsewhere

      // Creating the object for each order
      const toObject = {
        documentNumber: to.documentNumber,
        itemCodeDes: `${to.itemCode} / ${des ? des.substring(0, len) : ""}`,
        itemCode: to.itemCode,
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {to?.itemDescription?.length > 35 ? (
              <Tooltip title={to.itemDescription} style={{ cursor: "pointer" }}>
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {to.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {to.itemDescription}
              </MDTypography>
            )}
            {to?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        sku: to.cSku,
        qty: `${to.qty}`,
        uom: `${to.uom || ""}`,
        source: to.source,
        destination: to.destination,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: to.cd,
        suid: (
          <Tooltip title="View Suids">
            {viewSuids && (
              <ViewButton
                disabled={to.suids.length === 0}
                variant="gradient"
                color="info"
                iconOnly
                type="button"
                style={{ marginRight: "-1px", borderRadius: "5px" }}
                size="small"
                onClick={() => {
                  handleOpenCategoryLineItemsModal(to);
                  setCategoryItems(to.suids);
                }}
              >
                <Icon>visibility_icon</Icon>
              </ViewButton>
            )}
          </Tooltip>
        ),
        status: (
          <button
            className={
              to.status === 0
                ? "status-created"
                : to.status === 1
                  ? "status-success"
                  : ""
            }
            style={{ width: "5.5rem" }}
          >
            {to.status === 0
              ? "Created"
              : to.status === 1
                ? "Closed"
                : "Unknown"}
          </button>
        ),
        status2:
          to.status === 0 ? "Created" : to.status === 1 ? "Closed" : "Unknown",
      };

      tempTransferOrders.push(toObject);
    });

    // Only update state if data has changed
    if (JSON.stringify(tempTransferOrders) !== JSON.stringify(state.rows)) {
      setState((prevState) => ({ ...prevState, rows: tempTransferOrders }));
    }
  }, [transferOrders, state.rows]); // Add state.rows to the dependency array to optimize updates

  const [DownloadData, setDownloadData] = useState("");

  useEffect(() => {
    let tempTransferOrders = [];
    let data = getAllTransferOrdersDownloadReducer.transferOrders.data
      ? getAllTransferOrdersDownloadReducer.transferOrders.data
      : [];
    // setPaginationObj(getAllTransferOrdersDownloadReducer?.transferOrders?.pagination);
    // setLoading(getAllTransferOrdersDownloadReducer.loading);
    data.map((to) => {
      const formatDate = new Date(to.cd);
      let des = to?.itemDescription;
      let len = desLength;
      const toObject = {
        documentNumber: to.documentNumber,
        itemCodeDes: `${to.itemCode} / ${des ? des.substring(0, len) : ""}`,
        itemCode: to.itemCode,
        itemDescription: to.itemDescription,
        sku: to.cSku,
        qty: `${to.qty}`,
        uom: `${to.uom ? to.uom : ""}`,
        source: to.source,
        destination: to.destination,
        serialNumber: to.serialNumber,
        lotNumber: to.lotNumber,
        suid2: to.suid,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: to.cd,
        suid: (
          <Tooltip title="View Suids">
            {viewSuids && (
              <ViewButton
                // disabled={to.suids.length == 0}
                variant="gradient"
                color="info"
                iconOnly
                type="button"
                style={{ marginLeft: "-1px" }}
                onClick={() => {
                  handleOpenCategoryLineItemsModal(to);
                  setCategoryItems(to.suids);
                }}
              >
                <Icon>visibility_icon</Icon>
              </ViewButton>
            )}
          </Tooltip>
        ),
        status: (
          <button
            className={
              (to.status === 0 && `status-created`) ||
              (to.status === 1 && `status-success`)
            }
            style={{ width: "5.5rem" }}
          >
            {(to.status === 0 && `Created`) || (to.status === 1 && `Closed`)}
          </button>
        ),
        status2:
          (to.status === 0 && `Created`) || (to.status === 1 && `Closed`),
      };
      tempTransferOrders.push(toObject);
    });
    setDownloadData(tempTransferOrders);
  }, [getAllTransferOrdersDownloadReducer]);

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];

    data.map((item) => {
      tempItemCodeOptions.push({
        label: `${item.itemCode}/${item.itemDescription}`,
        value: item.itemId,
        itemId: item.itemId,
        itemCode: item.itemCode,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [suidOptions, setSuidOptions] = useState([]);

  useEffect(() => {
    let tempSuidOptions = [];
    let data = getSuidsReducer.suids.data ? getSuidsReducer.suids.data : [];

    data.map((suid) => {
      tempSuidOptions.push({
        label: suid.suid,
        value: suid.suid,
        sLocation: suid.locationCode,
        qty: suid.qty,
        itemId: suid.itemId,
        itemCode: suid.itemCode,
      });
    });
    setSuidOptions(tempSuidOptions);
  }, [getSuidsReducer]);

  const [documentTypeSelected, setDocumentTypeSelected] = useState("");

  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getDocumentTypeReducer.documentType.data
      ? getDocumentTypeReducer.documentType.data
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.documentName,
        value: document.documentCode,
        documentId: document.documentId,
      });
    });
    setDocumentTypeOptions(tempDocumentTypeOptions);
  }, [getDocumentTypeReducer]);

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setDwarehouseSelected("");
  };

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getCreatedActivityReducer.activity.data
      ? getCreatedActivityReducer.activity.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.mvtCode,
        value: activity.dAcnId,
        mvtId: activity.mvtId,
      });
    });
    setActivityOptions(tempCreatedActivityOptions);
  }, [getCreatedActivityReducer]);

  const handleDocumentTypeChange = (selectedDocumentType) => {
    setDocumentTypeSelected(selectedDocumentType);
    setActivityIdSelected("");
  };

  const initialValues = {
    movementType: "",
    documentNumber: "",
    transferOrderType: "suid",
    sourceLocation: "",
    destinationLocation: "",
    sWarehouse: "",
    sZone: "",
    sSection: "",
    sRack: "",
    sLocation: "",
    itemsForQty: [
      {
        itemId: "",
        qty: "",
        availableQty: "",
      },
    ],
    itemsForSuid: [
      {
        itemId: "",
        suids: "",
        sourceLocation: "",
        qty: "",
      },
    ],
    dWarehouse: "",
    dZone: "",
    dSection: "",
    dRack: "",
    dLocation: "",
  };

  const validationSchema = Yup.object({
    movementType: Yup.object().required("Select the movement type!"),
    documentNumber: Yup.string().required("Enter the document no!"),
    dWarehouse: Yup.object().required("Select the delivery warehouse!"),
    // dZone: Yup.object().required("Select the delivery zone!"),
  });

  const TransferOrderSuccessNotification = () =>
    toast.success("Transfer Order created successfully!", {
      position: "top-center",
      autoClose: 2000,
    });

  const TransferOrderFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const ReprintSUIDSuccessNotification = () =>
    toast.success("SUID reprinted successfully!", {
      position: "top-center",
      autoClose: 2000,
    });

  const [dLocationSelected, setDlocationSelected] = useState("");

  const [buttonName, setButtonName] = useState("Submit");

  const formattedDestinationLocation = [
    dWarehouseSelected?.label,
    dZoneSelected?.label,
    dSectionSelected?.label,
    dRackSelected?.label,
    dLocationSelected?.label,
  ]
    .filter(Boolean)
    .join("-");

  const onSubmitForCreateTransferOrder = async (values, { resetForm }) => {
    // setButtonName("Please wait...");
    if (values.transferOrderType === "qty") {
      let payload = {
        documentNumber: values.documentNumber.trim(),
        mvtId: activityIdSelected.mvtId ? activityIdSelected.mvtId : "",
        destinationLocation: values.destinationLocation,
        sourceLocation: values.sourceLocation,
        items: values.itemsForQty,
      };

      let res = await createTransferOrderForQtyW2(payload, jwtToken);

      if (res.status) {
        // setIsSuccessCreatedTransferOrder(true);
        TransferOrderSuccessNotification();
        getAllTransferOrders(pageNo, rowsPerPage, searchObject, jwtToken);
        resetForm();
        setSwarehouseSelected("");
        setSzoneSelected("");
        setSsectionSelected("");
        setSrackSelected("");
        setSlocationSelected("");
        setDwarehouseSelected("");
        setDzoneSelected("");
        setDsectionSelected("");
        setDrackSelected("");
        setDlocationSelected("");
        setDocumentTypeSelected("");
        setActivityIdSelected("");
        setTimeout(() => {
          handleCreateTransferOrderModal();
          setButtonName("Submit");
        }, 2500);
      }

      if (!res.status) {
        // setIsErrorCreatedTransferOrder(true);
        // setErrorMsgForCreate(res?.data?.data?.msg);
        setButtonName("Submit");
        TransferOrderFailureNotification(res?.data?.data?.msg);
      }
    }
    if (values.transferOrderType === "suid") {
      const firstItemId =
        values.itemsForSuid[0]?.itemId || selectedItemCode?.itemId;
      const updatedItemsForSuid = values.itemsForSuid.map((item) => ({
        ...item,
        itemId: firstItemId, // Set the itemId of all items to the first item's itemId
      }));

      let payload = {
        // documentNumber: values.documentNumber.trim(),

        mvtId: activityIdSelected.mvtId ? activityIdSelected.mvtId : "",
        itemCode: selectedItemCode.itemCode ? selectedItemCode.itemCode : "",
        destinationLocation: formattedDestinationLocation,
        items: updatedItemsForSuid,
        // reprint: isChecked === true ? 1 : 0,
        printerId: printerId,
      };

      let res = await createTransferOrderW2(payload, jwtToken);

      if (res.status) {
        // setIsSuccessCreatedTransferOrder(true);
        TransferOrderSuccessNotification();
        getAllTransferOrders(pageNo, rowsPerPage, searchObject, jwtToken);
        resetForm();
        setSwarehouseSelected("");
        setSzoneSelected("");
        setSsectionSelected("");
        setSrackSelected("");
        setSlocationSelected("");
        setDwarehouseSelected("");
        setDzoneSelected("");
        setDsectionSelected("");
        setDrackSelected("");
        setDlocationSelected("");
        setDocumentTypeSelected("");
        setActivityIdSelected("");
        setTimeout(() => {
          handleCreateTransferOrderModal();
          setButtonName("Submit");
        }, 2500);
      }

      if (!res.status) {
        // setIsErrorCreatedTransferOrder(true);
        // setErrorMsgForCreate(res?.data?.data?.msg);
        setButtonName("Submit");
        TransferOrderFailureNotification(res?.data?.data?.msg);
      }
    }
  };

  const [isSuccessCreatedTransferOrder, setIsSuccessCreatedTransferOrder] =
    useState(false);
  const [isErrorCreatedTransferOrder, setIsErrorCreatedTransferOrder] =
    useState(false);

  useEffect(() => {
    if (isErrorCreatedTransferOrder) {
      setTimeout(() => {
        setIsErrorCreatedTransferOrder(false);
      }, 3000);
    }
  }, [isErrorCreatedTransferOrder]);

  useEffect(() => {
    if (isSuccessCreatedTransferOrder) {
      setTimeout(() => {
        setIsSuccessCreatedTransferOrder(false);
      }, 3000);
    }
  }, [isSuccessCreatedTransferOrder]);

  const [createTransferOrderModal, setCreateTransferOrderModal] =
    useState(false);
  const handleCreateTransferOrderModal = () => {
    setSuidForItem("");
    setChecked(false);
    setItemCodeSelected("");
    setActivityIdSelected("");
    setDwarehouseSelected("");
    setDlocationSelected("");
    setDrackSelected("");
    setDzoneSelected("");
    setDsectionSelected("");
    setSelectedItemCode("");

    setCreateTransferOrderModal(!createTransferOrderModal);
  };

  const [itemCodeSelected, setItemCodeSelected] = useState("");

  const [sZoneSelected, setSzoneSelected] = useState("");
  const [sRackSelected, setSrackSelected] = useState("");
  const [sLocationSelected, setSlocationSelected] = useState("");
  const [sWarehouseSelected, setSwarehouseSelected] = useState("");

  const handleSwarehouseChange = (selectedData) => {
    setSwarehouseSelected(selectedData);
    setSzoneSelected("");
    setSsectionSelected("");
    setSrackSelected("");
    setSlocationSelected("");
  };

  const handleSzoneChange = (selectedRack) => {
    setSzoneSelected(selectedRack);
    setSsectionSelected("");
    setSrackSelected("");
    setSlocationSelected("");
  };

  const handleSsectionChange = (selectedRack) => {
    setSsectionSelected(selectedRack);
    setSrackSelected("");
    setSlocationSelected("");
  };

  const handleSrackChange = (selectedRack) => {
    setSrackSelected(selectedRack);
    setSlocationSelected("");
  };

  const handleSlocationChange = (selectedLocation) => {
    setSlocationSelected(selectedLocation);
  };

  const handleDwarehouseChange = (selectedData) => {
    setDwarehouseSelected(selectedData);
    setLevel1Options("");
    setDzoneSelected("");
    setDsectionSelected("");
    setDrackSelected("");
    setDlocationSelected("");
  };

  const handleDzoneChange = (selectedRack) => {
    setDzoneSelected(selectedRack);
    setDsectionSelected("");
    setDrackSelected("");
    setDlocationSelected("");
  };

  const handleDsectionChange = (selectedRack) => {
    setDsectionSelected(selectedRack);
    setDrackSelected("");
    setDlocationSelected("");
  };

  const handleDrackChange = (selectedRack) => {
    setDrackSelected(selectedRack);
    setDlocationSelected("");
  };

  const handleDlocationChange = (selectedLocation) => {
    setDlocationSelected(selectedLocation);
  };

  const [warehouseOptions, setWarehouseOptions] = useState([]);

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByItemCodeAndMovementReducer.warehouses.data
      ? getWarehouseByItemCodeAndMovementReducer.warehouses.data
      : [];

    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
        key: warehouse.warehouseCode,
      });
    });

    setWarehouseOptions(tempWarehouseOptions);

    // If there's only one warehouse, autofill it
    if (tempWarehouseOptions.length === 1 && autoPopulateLocationAccess) {
      setDwarehouseSelected(tempWarehouseOptions[0]);
    } else {
      // If there are more than 1, reset DzoneSelected to an empty value
      setDwarehouseSelected(null); // or you can set it to any default value
    }
  }, [getWarehouseByItemCodeAndMovementReducer]);
  // Source Options
  const [level1OptionsSrc, setLevel1OptionsSrc] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = level1ByLevelSrcReducer.level1ByLevel.data
      ? level1ByLevelSrcReducer.level1ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    setLevel1OptionsSrc(tempLevelOptions);

    // if (tempLevelOptions.length === 1) {
    //   setDzoneSelected(tempLevelOptions[0]);
    // }
  }, [level1ByLevelSrcReducer]);

  const [level2OptionsSrc, setLevel2OptionsSrc] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = level2ByLevelSrcReducer.level2ByLevel.data
      ? level2ByLevelSrcReducer.level2ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    setLevel2OptionsSrc(tempLevelOptions);
  }, [level2ByLevelSrcReducer]);

  const [level3OptionsSrc, setLevel3OptionsSrc] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = level3ByLevelSrcReducer.level3ByLevel.data
      ? level3ByLevelSrcReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    setLevel3OptionsSrc(tempLevelOptions);
  }, [level3ByLevelSrcReducer]);

  const [level4OptionsSrc, setLevel4OptionsSrc] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = level4ByLevelSrcReducer.level4ByLevel.data
      ? level4ByLevelSrcReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    setLevel4OptionsSrc(tempLevelOptions);
  }, [level4ByLevelSrcReducer]);

  // Delivery Options
  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    const data =
      getLevel1ByLevelForTransferOrderReducer.level1ByLevel.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      setLevel1Options([]);
      setDzoneSelected(null);
      return;
    }

    const tempLevelOptions = data.map((level) => ({
      label: level.locationName,
      value: level.locationId,
      key: level.locationName,
    }));

    setLevel1Options(tempLevelOptions);

    if (tempLevelOptions.length === 1 && autoPopulateLocationAccess) {
      const onlyOption = tempLevelOptions[0];
      setDzoneSelected((prev) =>
        prev?.value !== onlyOption.value ? onlyOption : prev,
      );
    } else {
      setDzoneSelected(null);
    }
  }, [getLevel1ByLevelForTransferOrderReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    setLevel2Options([]); // Clear old options first

    const data =
      getLevel2ByLevelForTransferOrderReducer.level2ByLevel.data || [];

    const tempLevelOptions = data.map((level) => ({
      label: level.locationName,
      value: level.locationId,
      key: level.locationName,
    }));

    setLevel2Options(tempLevelOptions);

    if (
      tempLevelOptions.length === 1 &&
      dZoneSelected &&
      autoPopulateLocationAccess
    ) {
      setDsectionSelected(tempLevelOptions[0]);
    } else {
      setDsectionSelected(null);
    }
  }, [
    getLevel2ByLevelForTransferOrderReducer,
    dZoneSelected, // Watch for changes to Level 1 selection
  ]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelForTransferOrderReducer.level3ByLevel.data
      ? getLevel3ByLevelForTransferOrderReducer.level3ByLevel.data
      : [];
    console.log("level3", data);

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    setLevel3Options(tempLevelOptions);

    if (
      tempLevelOptions.length === 1 &&
      (dZoneSelected || dSectionSelected) &&
      autoPopulateLocationAccess
    ) {
      setDrackSelected(tempLevelOptions[0]);
    } else {
      setDrackSelected(null);
    }
  }, [
    getLevel3ByLevelForTransferOrderReducer,
    dZoneSelected,
    dSectionSelected,
  ]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    setLevel4Options([]);

    const data =
      getLevel4ByLevelForTransferOrderReducer.level4ByLevel.data || [];

    const tempLevelOptions = data.map((warehouse) => ({
      label: warehouse.locationName,
      value: warehouse.locationId,
      key: warehouse.locationName,
    }));

    setLevel4Options(tempLevelOptions);

    if (
      tempLevelOptions.length === 1 &&
      (dZoneSelected || dSectionSelected || dRackSelected) &&
      autoPopulateLocationAccess
    ) {
      setDlocationSelected(tempLevelOptions[0]);
    } else {
      setDlocationSelected(null);
    }
  }, [
    getLevel4ByLevelForTransferOrderReducer,
    dRackSelected,
    dZoneSelected,
    dSectionSelected,
  ]);

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  useEffect(() => {
    if (dWarehouseSelected?.value && jwtToken) {
      getLevelsByWarehouse(dWarehouseSelected.value, jwtToken);
    }
  }, [dWarehouseSelected, jwtToken]);

  useEffect(() => {
    if (
      dWarehouseSelected?.value &&
      selectedItemCode?.itemId &&
      activityIdSelected?.value &&
      jwtToken
    ) {
      getLevel1ByLevelForTransferOrder(
        dWarehouseSelected.value,
        0,
        selectedItemCode.itemId,
        activityIdSelected.value,
        jwtToken,
      );
    }
  }, [dWarehouseSelected, selectedItemCode, activityIdSelected, jwtToken]);

  useEffect(() => {
    if (
      dWarehouseSelected?.value &&
      dZoneSelected?.value &&
      selectedItemCode?.itemId &&
      activityIdSelected?.value &&
      jwtToken
    ) {
      getLevel2ByLevelForTransferOrder(
        dWarehouseSelected.value,
        dZoneSelected.value,
        selectedItemCode?.itemId,
        activityIdSelected.value,
        jwtToken,
      );
    }
  }, [
    dWarehouseSelected,
    dZoneSelected,
    selectedItemCode,
    activityIdSelected,
    jwtToken,
  ]);

  useEffect(() => {
    if (
      dWarehouseSelected?.value &&
      dSectionSelected?.value &&
      selectedItemCode?.itemId &&
      activityIdSelected?.value &&
      jwtToken
    ) {
      getLevel3ByLevelForTransferOrder(
        dWarehouseSelected.value,
        dSectionSelected.value,
        selectedItemCode?.itemId,
        activityIdSelected.value,
        jwtToken,
      );
    }
  }, [
    dWarehouseSelected,
    dSectionSelected,
    selectedItemCode,
    activityIdSelected,
    jwtToken,
  ]);

  useEffect(() => {
    if (
      dWarehouseSelected?.value &&
      dRackSelected?.value &&
      selectedItemCode?.itemId &&
      activityIdSelected?.value &&
      jwtToken
    ) {
      getLevel4ByLevelForTransferOrder(
        dWarehouseSelected.value,
        dRackSelected.value,
        selectedItemCode?.itemId,
        activityIdSelected.value,
        jwtToken,
      );
    }
  }, [
    dWarehouseSelected,
    dRackSelected,
    selectedItemCode,
    activityIdSelected,
    jwtToken,
  ]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [isChecked, setChecked] = useState(false);

  const onChangeEvent = (e) => {
    setChecked(e.target.checked);
  };

  const headers = [
    {
      label: "Transfer Order No",
      key: "documentNumber",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "itemDescription", key: "itemDescription" },
    {
      label: "sourceLocation",
      key: "source",
    },

    {
      label: "Delivery Location",
      key: "destination",
    },
    {
      label: "qty",
      key: "qty",
    },
    {
      label: "uom",
      key: "uom",
    },
    {
      label: "status",
      key: "status2",
    },
    {
      label: "Suid",
      key: "suid2",
    },
    {
      label: "Lot Number",
      key: "lotNumber",
    },
    {
      label: "Serial Number",
      key: "serialNumber",
    },
    {
      label: "createdDate",
      key: "createdDate",
    },
  ];

  const csvLink = {
    filename: "Transfer Order List.csv",
    headers: headers,
    data: DownloadData,
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getAllTransferOrders(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [suidForItem, setSuidForItem] = useState("");

  useEffect(() => {
    getWarehousesByItemCodeAndMovement(
      activityIdSelected?.value,
      selectedItemCode?.itemId,
      jwtToken,
    );
  }, [activityIdSelected, selectedItemCode]);

  return (
    <>
      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                {createNewTransferOrder && (
                  <CreateButton
                    tooltip="Create Transfer Order"
                    style={{ marginRight: "1rem", borderRadius: "5px" }}
                    size="small"
                    color="info"
                    variant="contained"
                    type="button"
                    iconOnly
                    onClick={(event) => {
                      handleCreateTransferOrderModal();
                      getItemMaster(jwtToken);
                      getDocumentType(jwtToken);
                      getCreatedActivity("", jwtToken);
                    }}
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )}
                {downloadAccess ? (
                  <CSVLink {...csvLink}>
                    <Tooltip title="Download Transfer Order List">
                      <MDButton
                        style={{ marginRight: "1rem", borderRadius: "5px" }}
                        size="small"
                        type="button"
                        variant="outlined"
                        color="success"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </MDButton>
                    </Tooltip>
                  </CSVLink>
                ) : (
                  ""
                )}
              </MDBox>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    options={{ draggable: false }}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>

              <Modal
                open={openCategoryLineItemsModal}
                onClose={handleCloseCategoryLineItemsModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCategoryModal}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Suids
                    </MDTypography>
                    <MDBox>
                      <span>
                        <Tooltip title="Close">
                          <IconButton
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                              marginBottom: "5px",
                            }}
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseCategoryLineItemsModal}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />

                  <MDBox>
                    <DataTable
                      table={{ columns: categoryColumns, rows: categoryRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={createTransferOrderModal}
                onClose={handleCreateTransferOrderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCreate}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Create Transfer Order
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateTransferOrderModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox>
                      <MDBox>
                        <Grid container>
                          <Formik
                            initialValues={initialValues}
                            // validationSchema={validationSchema}
                            onSubmit={onSubmitForCreateTransferOrder}
                          >
                            {(formik) => {
                              return (
                                <Form>
                                  <div>
                                    <MDBox
                                    // style={{
                                    //   // position: "sticky",
                                    //   top: "0",
                                    //   width: "100%",
                                    //   // zIndex: 999,
                                    // }}
                                    >
                                      <Grid container>
                                        <Grid item xs={12} lg={6}>
                                          <MDBox display="flex">
                                            <MDBox
                                              mb={1}
                                              ml={1}
                                              style={{ width: "370px" }}
                                            >
                                              <MDTypography
                                                variant="h6"
                                                style={{ fontWeight: "500" }}
                                              >
                                                Movement Type
                                              </MDTypography>
                                              <Select
                                                isClearable
                                                className="select-css"
                                                maxMenuHeight={360}
                                                placeholder="Choose one..."
                                                name="movementType"
                                                onBlur={() => {
                                                  formik.handleBlur({
                                                    target: {
                                                      name: "movementType",
                                                    },
                                                  });
                                                }}
                                                value={activityIdSelected}
                                                options={activityOptions}
                                                onChange={(selectedOption) => {
                                                  handleActivityIdChange(
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "movementType",
                                                    selectedOption,
                                                  );
                                                  getWarehousesByItemCodeAndMovement(
                                                    selectedOption?.value,
                                                    selectedItemCode?.itemId,
                                                    jwtToken,
                                                  );
                                                }}
                                              />
                                              {formik.touched.movementType &&
                                                formik.errors.movementType && (
                                                  <TextError
                                                    msg={
                                                      formik.errors.movementType
                                                    }
                                                  />
                                                )}
                                            </MDBox>
                                            {/* <MDBox ml={5}>
                                              <MDTypography
                                                variant="h6"
                                                style={{ fontWeight: "500" }}
                                                mb={0.8}
                                              >
                                                Reprint SUID
                                              </MDTypography>
                                              <input
                                                type="checkbox"
                                                checked={isChecked}
                                                onChange={(e) =>
                                                  onChangeEvent(e)
                                                }
                                                style={{
                                                  zoom: 2,
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </MDBox> */}
                                          </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={6}>
                                          <MDBox ml={1}>
                                            <MDTypography variant="h6">
                                              Item Code/Des
                                            </MDTypography>
                                            <Select
                                              className="select-css-for-itemcode"
                                              maxMenuHeight={250}
                                              isDisabled={suidForItem}
                                              // menuPlacement="top"
                                              isClearable
                                              styles={{
                                                control: (provided) => ({
                                                  ...provided,
                                                  borderRadius: 5,
                                                  height: "12px",
                                                  marginTop: "-2px",
                                                  fontSize: "15px",
                                                }),
                                              }}
                                              options={itemCodeOptions}
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(
                                                  `itemsForSuid`,
                                                  [
                                                    {
                                                      suids: "",
                                                      sourceLocation: "",
                                                      qty: "",
                                                      newSuid: "",
                                                      split: undefined,
                                                    },
                                                  ],
                                                );
                                                if (selectedOption?.value) {
                                                  getSuids(
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                    activityIdSelected?.mvtId,
                                                    debouncedSearchTerm,
                                                    jwtToken,
                                                  );
                                                }
                                                setSelectedItemCode(
                                                  selectedOption,
                                                ); // Store the selected item code
                                                getWarehousesByItemCodeAndMovement(
                                                  activityIdSelected?.value,
                                                  selectedOption?.value,
                                                  jwtToken,
                                                );
                                              }}
                                              value={
                                                selectedItemCode
                                                  ? {
                                                      label:
                                                        selectedItemCode?.itemCode,
                                                      value:
                                                        selectedItemCode?.itemId,
                                                    }
                                                  : ""
                                              }
                                              placeholder="Choose one..."
                                            />
                                          </MDBox>
                                        </Grid>
                                      </Grid>
                                    </MDBox>

                                    <hr style={{ marginBottom: "10px" }} />

                                    {formik.values.transferOrderType ===
                                      "qty" && (
                                      <MDBox>
                                        <MDTypography variant="h5">
                                          Source Location
                                        </MDTypography>
                                        <hr style={{ marginBottom: "10px" }} />
                                        <Grid container>
                                          <Grid item xs={12} lg={4}>
                                            <MDBox
                                              mb={1}
                                              style={{ width: "370px" }}
                                            >
                                              <MDTypography
                                                variant="h6"
                                                style={{
                                                  fontWeight: "500",
                                                }}
                                              >
                                                WareHouse Code
                                              </MDTypography>
                                              <Select
                                                isClearable
                                                className="select-css"
                                                maxMenuHeight={90}
                                                placeholder="Choose one..."
                                                name="sWarehouse"
                                                onBlur={() => {
                                                  formik.handleBlur({
                                                    target: {
                                                      name: "sWarehouse",
                                                    },
                                                  });
                                                }}
                                                value={sWarehouseSelected}
                                                options={warehouseOptions}
                                                onChange={(selectedOption) => {
                                                  handleSwarehouseChange(
                                                    selectedOption,
                                                  );
                                                  getLevel1ByLevelSrc(
                                                    selectedOption?.value,
                                                    0,
                                                    jwtToken,
                                                  );
                                                  getLevel2ByLevelSrc(
                                                    selectedOption?.value,
                                                    0,
                                                    jwtToken,
                                                  );
                                                  getLevel3ByLevelSrc(
                                                    selectedOption?.value,
                                                    0,
                                                    jwtToken,
                                                  );
                                                  getLevel4ByLevelSrc(
                                                    selectedOption?.value,
                                                    0,
                                                    jwtToken,
                                                  );
                                                  formik.setFieldValue(
                                                    "sWarehouse",
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "sourceLocation",
                                                    `${
                                                      selectedOption?.label
                                                        ? selectedOption.label
                                                        : ""
                                                    }`,
                                                  );
                                                }}
                                              />
                                              {formik.touched.sWarehouse &&
                                                formik.errors.sWarehouse && (
                                                  <TextError
                                                    msg={
                                                      formik.errors.sWarehouse
                                                    }
                                                  />
                                                )}
                                            </MDBox>
                                          </Grid>
                                          <Grid item xs={12} lg={4}>
                                            <MDBox
                                              ml={1}
                                              style={{ width: "370px" }}
                                            >
                                              <MDTypography
                                                variant="h6"
                                                style={{
                                                  fontWeight: "500",
                                                }}
                                              >
                                                Level 1:-
                                                {data.length > 0
                                                  ? data[0].rltName
                                                  : "No data available"}
                                              </MDTypography>
                                              <Select
                                                isClearable
                                                // isDisabled={
                                                //   sWarehouseSelected
                                                //     ? false
                                                //     : true
                                                // }
                                                className="select-css"
                                                maxMenuHeight={90}
                                                placeholder="Choose one..."
                                                name="sZone"
                                                onBlur={() => {
                                                  formik.handleBlur({
                                                    target: {
                                                      name: "sZone",
                                                    },
                                                  });
                                                }}
                                                value={sZoneSelected}
                                                options={level1OptionsSrc}
                                                onChange={(selectedOption) => {
                                                  handleSzoneChange(
                                                    selectedOption,
                                                  );
                                                  getLevel2ByLevelSrc(
                                                    sWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel3ByLevelSrc(
                                                    sWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel4ByLevelSrc(
                                                    sWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    jwtToken,
                                                  );
                                                  formik.setFieldValue(
                                                    "sZone",
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "sourceLocation",
                                                    `${
                                                      formik.values.sWarehouse
                                                        ? formik.values
                                                            .sWarehouse.label
                                                        : ""
                                                    }${
                                                      selectedOption?.label
                                                        ? `-${selectedOption.label}`
                                                        : ""
                                                    }`,
                                                  );
                                                }}
                                              />
                                              {formik.touched.sZone &&
                                                formik.errors.sZone && (
                                                  <TextError
                                                    msg={formik.errors.sZone}
                                                  />
                                                )}
                                            </MDBox>
                                          </Grid>
                                          <Grid item xs={12} lg={4}>
                                            <MDBox
                                              mb={1}
                                              ml={1}
                                              style={{ width: "370px" }}
                                            >
                                              <MDTypography
                                                variant="h6"
                                                style={{
                                                  fontWeight: "500",
                                                }}
                                              >
                                                Level 2:-
                                                {data.length > 0
                                                  ? data[1].rltName
                                                  : "No data available"}
                                              </MDTypography>
                                              <Select
                                                isClearable
                                                // isDisabled={
                                                //   sZoneSelected ? false : true
                                                // }
                                                className="select-css"
                                                maxMenuHeight={90}
                                                placeholder="Choose one..."
                                                name="sSection"
                                                onBlur={() => {
                                                  formik.handleBlur({
                                                    target: {
                                                      name: "sSection",
                                                    },
                                                  });
                                                }}
                                                value={sSectionSelected}
                                                options={level2OptionsSrc}
                                                onChange={(selectedOption) => {
                                                  handleSsectionChange(
                                                    selectedOption,
                                                  );
                                                  getLevel3ByLevelSrc(
                                                    sWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel4ByLevelSrc(
                                                    sWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    jwtToken,
                                                  );
                                                  formik.setFieldValue(
                                                    "sSection",
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "sourceLocation",
                                                    `${
                                                      formik.values.sWarehouse
                                                        ? formik.values
                                                            .sWarehouse.label
                                                        : ""
                                                    }${
                                                      formik.values.sZone
                                                        ? `-${formik.values.sZone.label}`
                                                        : ""
                                                    }${
                                                      selectedOption?.label
                                                        ? `-${selectedOption.label}`
                                                        : ""
                                                    }`,
                                                  );
                                                }}
                                              />
                                              {formik.touched.sSection &&
                                                formik.errors.sSection && (
                                                  <TextError
                                                    msg={formik.errors.sSection}
                                                  />
                                                )}
                                            </MDBox>
                                          </Grid>
                                          <Grid item xs={12} lg={4}>
                                            <MDBox
                                              // ml={1}
                                              style={{ width: "370px" }}
                                            >
                                              <MDTypography
                                                variant="h6"
                                                style={{
                                                  fontWeight: "500",
                                                }}
                                              >
                                                Level 3:-
                                                {data.length > 0
                                                  ? data[2].rltName
                                                  : "No data available"}
                                              </MDTypography>
                                              <Select
                                                isClearable
                                                // isDisabled={
                                                //   sSectionSelected
                                                //     ? false
                                                //     : true
                                                // }
                                                className="select-css"
                                                maxMenuHeight={90}
                                                placeholder="Choose One..."
                                                name="sRack"
                                                onBlur={() => {
                                                  formik.handleBlur({
                                                    target: {
                                                      name: "sRack",
                                                    },
                                                  });
                                                }}
                                                value={sRackSelected}
                                                options={level3OptionsSrc}
                                                onChange={(selectedOption) => {
                                                  handleSrackChange(
                                                    selectedOption,
                                                  );
                                                  getLevel4ByLevelSrc(
                                                    sWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    jwtToken,
                                                  );
                                                  formik.setFieldValue(
                                                    "sRack",
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "sourceLocation",
                                                    `${
                                                      formik.values.sWarehouse
                                                        ? formik.values
                                                            .sWarehouse.label
                                                        : ""
                                                    }${
                                                      formik.values.sZone
                                                        ? `-${formik.values.sZone.label}`
                                                        : ""
                                                    }${
                                                      formik.values.sSection
                                                        ? `-${formik.values.sSection.label}`
                                                        : ""
                                                    }${
                                                      selectedOption?.label
                                                        ? `-${selectedOption.label}`
                                                        : ""
                                                    }`,
                                                  );
                                                }}
                                              />
                                              {formik.touched.sRack &&
                                                formik.errors.sRack && (
                                                  <TextError
                                                    msg={formik.errors.sRack}
                                                  />
                                                )}
                                            </MDBox>
                                          </Grid>
                                          <Grid item xs={12} lg={4}>
                                            <MDBox
                                              mb={1}
                                              ml={1}
                                              style={{ width: "370px" }}
                                            >
                                              <MDTypography
                                                variant="h6"
                                                style={{
                                                  fontWeight: "500",
                                                }}
                                              >
                                                {data.length > 0
                                                  ? data[3].rltName
                                                  : "No data available"}
                                              </MDTypography>
                                              <Select
                                                isClearable
                                                // isDisabled={
                                                //   sRackSelected ? false : true
                                                // }
                                                className="select-css"
                                                maxMenuHeight={90}
                                                placeholder="Choose one..."
                                                name="sLocation"
                                                onBlur={() => {
                                                  formik.handleBlur({
                                                    target: {
                                                      name: "sLocation",
                                                    },
                                                  });
                                                }}
                                                value={sLocationSelected}
                                                options={level4OptionsSrc}
                                                onChange={(selectedOption) => {
                                                  handleSlocationChange(
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "sLocation",
                                                    selectedOption,
                                                  );
                                                  formik.setFieldValue(
                                                    "sourceLocation",
                                                    `${
                                                      formik.values.sWarehouse
                                                        ? formik.values
                                                            .sWarehouse.label
                                                        : ""
                                                    }${
                                                      formik.values.sZone
                                                        ? `-${formik.values.sZone.label}`
                                                        : ""
                                                    }${
                                                      formik.values.sSection
                                                        ? `-${formik.values.sSection.label}`
                                                        : ""
                                                    }${
                                                      formik.values.sRack
                                                        ? `-${formik.values.sRack.label}`
                                                        : ""
                                                    }${
                                                      selectedOption?.label
                                                        ? `-${selectedOption.label}`
                                                        : ""
                                                    }`,
                                                  );
                                                }}
                                              />
                                              {formik.touched.sLocation &&
                                                formik.errors.sLocation && (
                                                  <TextError
                                                    msg={
                                                      formik.errors.sLocation
                                                    }
                                                  />
                                                )}
                                            </MDBox>
                                          </Grid>
                                        </Grid>
                                      </MDBox>
                                    )}
                                    {/* {formik.values.transferOrderType ===
                                      "suid" && ( */}
                                    <MDBox>
                                      <MDTypography variant="h5">
                                        SUIDS
                                      </MDTypography>
                                      <hr style={{ marginBottom: "10px" }} />

                                      <FieldArray name="itemsForSuid">
                                        {(fieldArrayProps) => {
                                          const { push, remove, form } =
                                            fieldArrayProps;
                                          const { values } = form;
                                          const { itemsForSuid } = values;

                                          // Get a set of already selected SUIDs
                                          const selectedSuids = new Set(
                                            itemsForSuid.map(
                                              (item) => item.suids,
                                            ),
                                          );

                                          return (
                                            <div>
                                              {itemsForSuid.map(
                                                (item, index) => {
                                                  const availableOptions =
                                                    suidOptions.filter(
                                                      (option) =>
                                                        !selectedSuids.has(
                                                          option.value,
                                                        ),
                                                    );

                                                  const preselectedItemCode =
                                                    index > 0 &&
                                                    itemsForSuid[index - 1]
                                                      .itemId
                                                      ? itemsForSuid[index - 1]
                                                          .itemId
                                                      : selectedItemCode?.itemId;

                                                  return (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                      key={index}
                                                    >
                                                      <Grid container>
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          lg={2.8}
                                                        >
                                                          <MDBox ml={0}>
                                                            <MDTypography variant="h6">
                                                              SUID
                                                            </MDTypography>
                                                            <Select
                                                              className="select-css"
                                                              maxMenuHeight={
                                                                230
                                                              }
                                                              menuPlacement="top"
                                                              disabled={
                                                                availableOptions.length ===
                                                                0
                                                              }
                                                              onInputChange={(
                                                                newValue,
                                                              ) =>
                                                                setSearchTerm(
                                                                  newValue,
                                                                )
                                                              }
                                                              isClearable
                                                              // onInputChange={(
                                                              //   newValue
                                                              // ) =>
                                                              //   setSearchTerm(
                                                              //     newValue
                                                              //   )
                                                              // }
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "12px",
                                                                  marginTop:
                                                                    "-2px",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              options={
                                                                availableOptions
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                !selectedItemCode &&
                                                                  setSelectedItemCode(
                                                                    selectedOption,
                                                                  );
                                                                setSuidForItem(
                                                                  selectedOption,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForSuid.${index}.itemId`,
                                                                  selectedOption?.itemId,
                                                                );
                                                                // getWarehousesByItemCodeAndMovement(
                                                                //   activityIdSelected?.value,
                                                                //   selectedOption?.itemId,
                                                                //   jwtToken
                                                                // );
                                                                formik.setFieldValue(
                                                                  `itemsForSuid.${index}.suids`,
                                                                  selectedOption?.value,
                                                                );

                                                                formik.setFieldValue(
                                                                  `itemsForSuid.${index}.sourceLocation`,
                                                                  selectedOption?.sLocation,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForSuid.${index}.qty`,
                                                                  selectedOption?.qty,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForSuid.${index}.newSuid`,
                                                                  "",
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForSuid.${index}.split`,
                                                                  "",
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForSuid.${index}.kitted`,
                                                                  0,
                                                                );
                                                              }}
                                                              // value={suidOptions.find(
                                                              //   (option) =>
                                                              //     option.value ===
                                                              //     item.suids
                                                              // )}
                                                              value={
                                                                item.suids
                                                                  ? itemCodeOptions.find(
                                                                      (
                                                                        option,
                                                                      ) =>
                                                                        option.value ===
                                                                        item.suids,
                                                                    )
                                                                  : null
                                                              }
                                                              placeholder="Choose one..."
                                                            />
                                                          </MDBox>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          lg={1}
                                                          ml={-0.5}
                                                        >
                                                          <Tooltip title="Reprint SUID">
                                                            <MDButton
                                                              disabled={
                                                                !itemsForSuid[
                                                                  index
                                                                ].suids
                                                              }
                                                              iconOnly
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                marginLeft:
                                                                  "10px",
                                                                marginTop:
                                                                  "23px",
                                                              }}
                                                              type="button"
                                                              onClick={async () => {
                                                                let res =
                                                                  await reprint(
                                                                    {
                                                                      suid: itemsForSuid[
                                                                        index
                                                                      ].suids,

                                                                      printerId:
                                                                        printerId,
                                                                    },
                                                                    jwtToken,
                                                                  );

                                                                if (
                                                                  res.status ===
                                                                  true
                                                                ) {
                                                                  ReprintSUIDSuccessNotification();
                                                                }
                                                              }}
                                                              color="success"
                                                            >
                                                              <Icon>print</Icon>
                                                            </MDButton>
                                                          </Tooltip>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          lg={1.5}
                                                          mr={13}
                                                          ml={-8}
                                                        >
                                                          <MDBox ml={1}>
                                                            <MDTypography variant="h6">
                                                              Source Location
                                                            </MDTypography>
                                                            <Field
                                                              disabled
                                                              className="form-control"
                                                              style={{
                                                                borderRadius: 5,
                                                                marginLeft: 0,
                                                                height: 36,
                                                                paddingLeft:
                                                                  "15px",
                                                                width: "280px",
                                                              }}
                                                              type="text"
                                                              name={`itemsForSuid.${index}.sourceLocation`}
                                                              value={
                                                                itemsForSuid[
                                                                  index
                                                                ]
                                                                  ?.sourceLocation
                                                              }
                                                              fullWidth
                                                              autoComplete="off"
                                                              onChange={
                                                                formik.handleChange
                                                              }
                                                              // error={
                                                              //   formik.touched
                                                              //     .sLocation &&
                                                              //   formik.errors
                                                              //     .sLocation &&
                                                              //   true
                                                              // }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                },
                                                                maxLength: 45,
                                                                readOnly: true,
                                                              }}
                                                            />

                                                            {formik.touched
                                                              .sLocation &&
                                                              formik.errors
                                                                .sLocation && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .sLocation
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          lg={1}
                                                          ml={1}
                                                          mr={1}
                                                        >
                                                          <MDBox ml={1}>
                                                            <MDTypography variant="h6">
                                                              QTY
                                                            </MDTypography>
                                                            <Field
                                                              disabled
                                                              className="form-control"
                                                              style={{
                                                                borderRadius: 5,
                                                                marginLeft: 2,
                                                                height: 36,
                                                                paddingLeft:
                                                                  "15px",
                                                                width: "80px",
                                                              }}
                                                              type="text"
                                                              name={`itemsForSuid.${index}.qty`}
                                                              value={
                                                                itemsForSuid[
                                                                  index
                                                                ]?.qty
                                                              }
                                                              fullWidth
                                                              autoComplete="off"
                                                              onChange={
                                                                formik.handleChange
                                                              }
                                                              // error={
                                                              //   formik.touched
                                                              //     .sLocation &&
                                                              //   formik.errors
                                                              //     .sLocation &&
                                                              //   true
                                                              // }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                },
                                                                maxLength: 45,
                                                                readOnly: true,
                                                              }}
                                                            />

                                                            {formik.touched
                                                              .qty &&
                                                              formik.errors
                                                                .qty && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .qty
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>

                                                        <Grid
                                                          item
                                                          xs={12}
                                                          lg={1}
                                                          ml={-4}
                                                          mr={1}
                                                        >
                                                          <MDBox ml={1}>
                                                            <MDTypography variant="h6">
                                                              New QTY
                                                            </MDTypography>
                                                            <Field
                                                              className="form-control"
                                                              max={
                                                                itemsForSuid[
                                                                  index
                                                                ]?.qty - 1
                                                              }
                                                              min={0}
                                                              style={{
                                                                borderRadius: 5,
                                                                marginLeft: 0,
                                                                height: 36,
                                                                paddingLeft:
                                                                  "15px",
                                                                width: "80px",
                                                              }}
                                                              type="text"
                                                              name={`itemsForSuid.${index}.split`}
                                                              value={
                                                                itemsForSuid[
                                                                  index
                                                                ]?.split
                                                              }
                                                              fullWidth
                                                              autoComplete="off"
                                                              onChange={
                                                                formik.handleChange
                                                              }
                                                              // error={
                                                              //   formik.touched
                                                              //     .sLocation &&
                                                              //   formik.errors
                                                              //     .sLocation &&
                                                              //   true
                                                              // }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                },
                                                                maxLength: 45,
                                                                readOnly: true,
                                                              }}
                                                            />

                                                            {(itemsForSuid[
                                                              index
                                                            ]?.split >=
                                                              itemsForSuid[
                                                                index
                                                              ]?.qty && (
                                                              <TextError msg="Invalid quantity" />
                                                            )) ||
                                                              (itemsForSuid[
                                                                index
                                                              ]?.split ===
                                                                0 && (
                                                                // itemsForSuid[
                                                                //   index
                                                                // ]?.split !==
                                                                //   "" &&
                                                                <TextError msg="Invalid quantity" />
                                                              ))}
                                                          </MDBox>
                                                        </Grid>
                                                        {itemsForSuid[index]
                                                          ?.newSuid && (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            lg={1.5}
                                                            mr={4}
                                                            ml={-4}
                                                          >
                                                            <MDBox ml={1}>
                                                              <MDTypography variant="h6">
                                                                New SUID
                                                              </MDTypography>
                                                              <Field
                                                                disabled
                                                                className="form-control"
                                                                style={{
                                                                  borderRadius: 5,
                                                                  marginLeft: 0,
                                                                  height: 36,
                                                                  paddingLeft:
                                                                    "15px",
                                                                  width:
                                                                    "250px",
                                                                }}
                                                                type="text"
                                                                name={`itemsForSuid.${index}.newSuid`}
                                                                value={
                                                                  itemsForSuid[
                                                                    index
                                                                  ]?.newSuid
                                                                }
                                                                fullWidth
                                                                autoComplete="off"
                                                                onChange={
                                                                  formik.handleChange
                                                                }
                                                                // error={
                                                                //   formik.touched
                                                                //     .sLocation &&
                                                                //   formik.errors
                                                                //     .sLocation &&
                                                                //   true
                                                                // }
                                                                inputProps={{
                                                                  style: {
                                                                    height:
                                                                      "14px",
                                                                  },
                                                                  maxLength: 45,
                                                                  readOnly: true,
                                                                }}
                                                              />

                                                              {formik.touched
                                                                .newSuid &&
                                                                formik.errors
                                                                  .newSuid && (
                                                                  <TextError
                                                                    msg={
                                                                      formik
                                                                        .errors
                                                                        .newSuid
                                                                    }
                                                                  />
                                                                )}
                                                            </MDBox>

                                                            {/* <MDButton
                                                                                               style={{
                                                                                                 marginLeft:
                                                                                                   "10px",
                                                                                                 marginTop:
                                                                                                   "22px",
                                                                                               }}
                                                                                               color="info"
                                                                                               type="button"
                                                                                               onClick={() => {
                                                                                                 splitQty(
                                                                                                   formik.values
                                                                                                     .suid,
                                                                                                   formik.values
                                                                                                     .split,
                                                                                                   printerId,
                                                                                                   jwtToken
                                                                                                 );
                                                                                               }}
                                                                                             >
                                                                                               <Icon>
                                                                                                 device_hub
                                                                                               </Icon>
                                                                                             </MDButton> */}
                                                          </Grid>
                                                        )}

                                                        <Grid
                                                          item
                                                          xs={12}
                                                          lg={1}
                                                          ml={
                                                            itemsForSuid[index]
                                                              ?.newSuid
                                                              ? 6
                                                              : -4.5
                                                          }
                                                          mr={-5}
                                                        >
                                                          {splitSuidAccess && (
                                                            <Tooltip title="Split Qty">
                                                              <MDButton
                                                                disabled={
                                                                  itemsForSuid[
                                                                    index
                                                                  ].split ==
                                                                    null ||
                                                                  itemsForSuid[
                                                                    index
                                                                  ]?.split >=
                                                                    itemsForSuid[
                                                                      index
                                                                    ]?.qty ||
                                                                  itemsForSuid[
                                                                    index
                                                                  ]?.split ==
                                                                    0 ||
                                                                  itemsForSuid[
                                                                    index
                                                                  ]?.newSuid !==
                                                                    ""
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  marginLeft:
                                                                    "10px",
                                                                  marginTop:
                                                                    "23px",
                                                                }}
                                                                iconOnly
                                                                type="button"
                                                                onClick={async () => {
                                                                  let res =
                                                                    await splitQty(
                                                                      itemsForSuid[
                                                                        index
                                                                      ].suids,
                                                                      itemsForSuid[
                                                                        index
                                                                      ].split,
                                                                      printerId,
                                                                      jwtToken,
                                                                    );

                                                                  formik.setFieldValue(
                                                                    `itemsForSuid.${index}.newSuid`,
                                                                    res?.data
                                                                      .data[0]
                                                                      .suid,
                                                                  );
                                                                  formik.setFieldValue(
                                                                    `itemsForSuid.${index}.kitted`,
                                                                    1,
                                                                  );
                                                                }}
                                                                color="info"
                                                              >
                                                                <Icon>
                                                                  device_hub
                                                                </Icon>
                                                              </MDButton>
                                                            </Tooltip>
                                                          )}
                                                        </Grid>
                                                        {itemsForSuid[index]
                                                          .newSuid && (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            lg={1}
                                                            ml={-3.5}
                                                            mr={-8}
                                                          >
                                                            <Tooltip title="Reprint New SUID">
                                                              <MDButton
                                                                disabled={
                                                                  !itemsForSuid[
                                                                    index
                                                                  ].newSuid
                                                                }
                                                                iconOnly
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  marginLeft:
                                                                    "10px",
                                                                  marginTop:
                                                                    "23px",
                                                                }}
                                                                type="button"
                                                                onClick={async () => {
                                                                  let res =
                                                                    await reprint(
                                                                      {
                                                                        suid: itemsForSuid[
                                                                          index
                                                                        ]
                                                                          .newSuid,

                                                                        printerId:
                                                                          printerId,
                                                                      },
                                                                      jwtToken,
                                                                    );
                                                                  if (
                                                                    res.status ===
                                                                    true
                                                                  ) {
                                                                    ReprintSUIDSuccessNotification();
                                                                  }
                                                                }}
                                                                color="success"
                                                              >
                                                                <Icon>
                                                                  print
                                                                </Icon>
                                                              </MDButton>
                                                            </Tooltip>
                                                          </Grid>
                                                        )}
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            marginTop: "1.5rem",
                                                            marginLeft: "0rem",
                                                          }}
                                                        >
                                                          <div className="col">
                                                            {index > 0 && (
                                                              <CancelIcon
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                type="button"
                                                                className="secondary"
                                                                onClick={() =>
                                                                  remove(index)
                                                                }
                                                                color="error"
                                                              />
                                                            )}
                                                          </div>
                                                          {index ===
                                                            itemsForSuid.length -
                                                              1 && (
                                                            <div>
                                                              <Tooltip title="Add Items">
                                                                <AddCircleIcon
                                                                  fontSize="large"
                                                                  onClick={() =>
                                                                    push({
                                                                      itemId:
                                                                        "",
                                                                      suids: "",
                                                                      sourceLocation:
                                                                        "",
                                                                      qty: "",
                                                                    })
                                                                  }
                                                                  color="info"
                                                                  style={{
                                                                    width:
                                                                      "30px",
                                                                    marginLeft:
                                                                      "0rem",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                />
                                                              </Tooltip>
                                                            </div>
                                                          )}
                                                        </span>
                                                      </Grid>
                                                    </div>
                                                  );
                                                },
                                              )}
                                            </div>
                                          );
                                        }}
                                      </FieldArray>
                                    </MDBox>
                                    {/* )} */}

                                    {formik.values.transferOrderType ===
                                      "qty" && (
                                      <MDBox>
                                        <MDTypography variant="h5">
                                          Items
                                        </MDTypography>
                                        <hr style={{ marginBottom: "10px" }} />

                                        <FieldArray name="itemsForQty">
                                          {(fieldArrayProps) => {
                                            const { push, remove, form } =
                                              fieldArrayProps;
                                            const { values } = form;
                                            const { itemsForQty } = values;

                                            return (
                                              <div
                                              // style={{
                                              //   overflowY: "auto",
                                              //   // maxHeight:
                                              //   //   "calc(60vh - 120px)",
                                              // }}
                                              >
                                                {itemsForQty.map(
                                                  (item, index) => {
                                                    return (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                        key={index}
                                                      >
                                                        <Grid container>
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                          >
                                                            <MDBox ml={1}>
                                                              <MDTypography variant="h6">
                                                                Item Code/Des -{" "}
                                                                {index + 1}
                                                              </MDTypography>
                                                              <Select
                                                                className="select-css-for-itemcode"
                                                                maxMenuHeight={
                                                                  90
                                                                }
                                                                isDisabled={
                                                                  formik.values
                                                                    .transferOrderType ===
                                                                    "qty" &&
                                                                  sWarehouseSelected &&
                                                                  sZoneSelected
                                                                    ? false
                                                                    : true
                                                                }
                                                                isClearable
                                                                styles={{
                                                                  control: (
                                                                    provided,
                                                                  ) => ({
                                                                    ...provided,
                                                                    borderRadius: 5,
                                                                    height:
                                                                      "12px",
                                                                    marginTop:
                                                                      "-2px",
                                                                    fontSize:
                                                                      "15px",
                                                                  }),
                                                                }}
                                                                options={
                                                                  itemCodeOptions
                                                                }
                                                                onChange={async (
                                                                  selectedOption,
                                                                ) => {
                                                                  let res =
                                                                    await getAvailableQtyForTo(
                                                                      selectedOption?.value,
                                                                      formik
                                                                        .values
                                                                        .sourceLocation,
                                                                      jwtToken,
                                                                    );

                                                                  formik.setFieldValue(
                                                                    `itemsForQty.${index}.availableQty`,
                                                                    res?.data
                                                                      ?.data
                                                                      ?.qty,
                                                                  );

                                                                  formik.setFieldValue(
                                                                    `itemsForQty.${index}.itemId`,
                                                                    selectedOption?.value,
                                                                  );
                                                                }}
                                                                value={
                                                                  itemsForQty.itemId
                                                                }
                                                                placeholder="Choose one..."
                                                              />
                                                            </MDBox>
                                                          </Grid>

                                                          {/* {values.lineItems[0]
                                                            .itemCodeDes &&
                                                            getAvailableQtyForTo(
                                                              values
                                                                .lineItems[0]
                                                                .itemCodeDes,
                                                              "",
                                                              jwtToken
                                                            )} */}

                                                          <Grid
                                                            item
                                                            xs={12}
                                                            lg={3}
                                                          >
                                                            <MDBox
                                                              mb={2}
                                                              ml={1}
                                                            >
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  borderRadius: 5,
                                                                }}
                                                              >
                                                                <MDTypography
                                                                  variant="h6"
                                                                  style={{
                                                                    fontWeight: 500,
                                                                  }}
                                                                >
                                                                  Qty
                                                                  <span
                                                                    style={{
                                                                      marginLeft:
                                                                        "7rem",
                                                                    }}
                                                                  >
                                                                    Available
                                                                    Qty:{" "}
                                                                    {
                                                                      itemsForQty[
                                                                        index
                                                                      ]
                                                                        ?.availableQty
                                                                    }
                                                                  </span>
                                                                </MDTypography>
                                                              </div>
                                                              <Field
                                                                className="form-control"
                                                                style={{
                                                                  borderRadius: 5,
                                                                  marginLeft: 0,
                                                                  height: 36,
                                                                  paddingLeft:
                                                                    "15px",
                                                                }}
                                                                fullWidth
                                                                type="number"
                                                                name={`itemsForQty[${index}].qty`}
                                                                value={
                                                                  itemsForQty[
                                                                    index
                                                                  ]?.qty
                                                                }
                                                                required
                                                                max={
                                                                  itemsForQty[
                                                                    index
                                                                  ]
                                                                    ?.availableQty
                                                                }
                                                                autoComplete="off"
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  formik.handleChange(
                                                                    e,
                                                                  );
                                                                }}
                                                                // error={
                                                                //   formik.touched
                                                                //     .qty &&
                                                                //   formik.errors
                                                                //     .qty &&
                                                                //   true
                                                                // }
                                                                inputProps={{
                                                                  style: {
                                                                    height:
                                                                      "14px",
                                                                    width:
                                                                      "150px",
                                                                  },
                                                                  maxLength: 45,
                                                                }}
                                                              />

                                                              {formik.touched
                                                                .qty &&
                                                                formik.errors
                                                                  .qty && (
                                                                  <TextError
                                                                    msg={
                                                                      formik
                                                                        .errors
                                                                        .qty
                                                                    }
                                                                  />
                                                                )}
                                                            </MDBox>
                                                          </Grid>

                                                          <span
                                                            style={{
                                                              display: "flex",
                                                              marginTop:
                                                                "1.5rem",
                                                              marginLeft:
                                                                "2rem",
                                                            }}
                                                          >
                                                            <div className="col">
                                                              {index > 0 && (
                                                                <CancelIcon
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  type="button"
                                                                  className="secondary"
                                                                  onClick={() =>
                                                                    remove(
                                                                      index,
                                                                    )
                                                                  }
                                                                  color="error"
                                                                />
                                                              )}
                                                            </div>
                                                            {index ===
                                                              itemsForQty.length -
                                                                1 && (
                                                              <div>
                                                                <Tooltip title="Add Items">
                                                                  <AddCircleIcon
                                                                    fontSize="large"
                                                                    onClick={() =>
                                                                      push({
                                                                        itemId:
                                                                          "",
                                                                        qty: "",
                                                                        availableQty:
                                                                          "",
                                                                      })
                                                                    }
                                                                    color="info"
                                                                    style={{
                                                                      width:
                                                                        "30px",
                                                                      marginLeft:
                                                                        "0rem",
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                  />
                                                                </Tooltip>
                                                              </div>
                                                            )}
                                                          </span>
                                                        </Grid>
                                                      </div>
                                                    );
                                                  },
                                                )}
                                              </div>
                                            );
                                          }}
                                        </FieldArray>
                                      </MDBox>
                                    )}

                                    <MDBox mt={2}>
                                      <MDTypography variant="h5">
                                        Delivery Location
                                      </MDTypography>
                                      <hr style={{ marginBottom: "10px" }} />
                                      <Grid container>
                                        <Grid item xs={12} lg={4}>
                                          <MDBox
                                            mb={1}
                                            style={{ width: "370px" }}
                                          >
                                            <MDTypography
                                              variant="h6"
                                              style={{
                                                fontWeight: "500",
                                              }}
                                            >
                                              WareHouse Code
                                            </MDTypography>
                                            <Select
                                              isClearable
                                              className="select-css"
                                              maxMenuHeight={350}
                                              placeholder="Choose one..."
                                              name="dWarehouse"
                                              onBlur={() => {
                                                formik.handleBlur({
                                                  target: {
                                                    name: "dWarehouse",
                                                  },
                                                });
                                              }}
                                              menuPlacement="top"
                                              menuPosition="absolute"
                                              value={dWarehouseSelected}
                                              options={warehouseOptions}
                                              onChange={(selectedOption) => {
                                                handleDwarehouseChange(
                                                  selectedOption,
                                                );

                                                // Ensure all required values are defined before calling the API
                                                if (
                                                  selectedOption?.value &&
                                                  selectedItemCode?.itemId &&
                                                  activityIdSelected?.value &&
                                                  jwtToken
                                                ) {
                                                  // Call the API functions if all values are defined
                                                  getLevel1ByLevelForTransferOrder(
                                                    selectedOption?.value,
                                                    0,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel2ByLevelForTransferOrder(
                                                    selectedOption?.value,
                                                    0,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel3ByLevelForTransferOrder(
                                                    selectedOption?.value,
                                                    0,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel4ByLevelForTransferOrder(
                                                    selectedOption?.value,
                                                    0,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                }

                                                formik.setFieldValue(
                                                  "dWarehouse",
                                                  selectedOption,
                                                );
                                                formik.setFieldValue(
                                                  "destinationLocation",
                                                  `${
                                                    selectedOption?.label
                                                      ? selectedOption.label
                                                      : ""
                                                  }`,
                                                );
                                              }}
                                            />
                                            {formik.touched.dWarehouse &&
                                              formik.errors.dWarehouse && (
                                                <TextError
                                                  msg={formik.errors.dWarehouse}
                                                />
                                              )}
                                          </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                          <MDBox
                                            ml={1}
                                            style={{ width: "370px" }}
                                          >
                                            <MDTypography
                                              variant="h6"
                                              style={{
                                                fontWeight: "500",
                                              }}
                                            >
                                              Level 1:-
                                              {data.length > 0
                                                ? data[0].rltName
                                                : "No data available"}
                                            </MDTypography>
                                            <Select
                                              menuPlacement="top"
                                              menuPosition="absolute"
                                              isClearable
                                              isDisabled={
                                                (dWarehouseSelected
                                                  ? false
                                                  : true) ||
                                                levelOptions[0]?.value !== 1
                                              }
                                              className="select-css"
                                              maxMenuHeight={350}
                                              placeholder="Choose one..."
                                              name="dZone"
                                              onBlur={() => {
                                                formik.handleBlur({
                                                  target: {
                                                    name: "dZone",
                                                  },
                                                });
                                              }}
                                              value={dZoneSelected}
                                              options={level1Options}
                                              onChange={(selectedOption) => {
                                                handleDzoneChange(
                                                  selectedOption,
                                                );

                                                // Ensure all required values are defined before calling the API
                                                if (
                                                  dWarehouseSelected?.value &&
                                                  selectedOption?.value &&
                                                  selectedItemCode?.itemId &&
                                                  activityIdSelected?.value &&
                                                  jwtToken
                                                ) {
                                                  // Call the API functions if all values are defined
                                                  getLevel2ByLevelForTransferOrder(
                                                    dWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel3ByLevelForTransferOrder(
                                                    dWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel4ByLevelForTransferOrder(
                                                    dWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                }

                                                formik.setFieldValue(
                                                  "dZone",
                                                  selectedOption,
                                                );
                                                formik.setFieldValue(
                                                  "destinationLocation",
                                                  `${
                                                    formik.values.dWarehouse
                                                      ? formik.values.dWarehouse
                                                          .label
                                                      : ""
                                                  }${
                                                    selectedOption?.label
                                                      ? `-${selectedOption.label}`
                                                      : ""
                                                  }`,
                                                );
                                              }}
                                            />
                                            {formik.touched.dZone &&
                                              formik.errors.dZone && (
                                                <TextError
                                                  msg={formik.errors.dZone}
                                                />
                                              )}
                                          </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                          <MDBox
                                            mb={1}
                                            ml={1}
                                            style={{ width: "370px" }}
                                          >
                                            <MDTypography
                                              variant="h6"
                                              style={{
                                                fontWeight: "500",
                                              }}
                                            >
                                              Level 2:-
                                              {data.length > 0
                                                ? data[1].rltName
                                                : "No data available"}
                                            </MDTypography>
                                            <Select
                                              menuPlacement="top"
                                              menuPosition="absolute"
                                              isClearable
                                              isDisabled={
                                                (levelOptions[0]?.value == 1 &&
                                                  !dZoneSelected) ||
                                                !(
                                                  levelOptions[0]?.value ===
                                                    2 ||
                                                  levelOptions[1]?.value === 2
                                                )
                                              }
                                              className="select-css"
                                              maxMenuHeight={350}
                                              placeholder="Choose one..."
                                              name="dSection"
                                              onBlur={() => {
                                                formik.handleBlur({
                                                  target: {
                                                    name: "dSection",
                                                  },
                                                });
                                              }}
                                              value={dSectionSelected}
                                              options={level2Options}
                                              onChange={(selectedOption) => {
                                                handleDsectionChange(
                                                  selectedOption,
                                                );

                                                // Ensure all required values are defined before calling the API
                                                if (
                                                  dWarehouseSelected?.value &&
                                                  selectedOption?.value &&
                                                  selectedItemCode?.itemId &&
                                                  activityIdSelected?.value &&
                                                  jwtToken
                                                ) {
                                                  // Call the API functions if all values are defined
                                                  getLevel3ByLevelForTransferOrder(
                                                    dWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                  getLevel4ByLevelForTransferOrder(
                                                    dWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                }

                                                formik.setFieldValue(
                                                  "dSection",
                                                  selectedOption,
                                                );
                                                formik.setFieldValue(
                                                  "destinationLocation",
                                                  `${
                                                    formik.values.dWarehouse
                                                      ? formik.values.dWarehouse
                                                          .label
                                                      : ""
                                                  }${
                                                    formik.values.dZone
                                                      ? `-${formik.values.dZone.label}`
                                                      : ""
                                                  }${
                                                    selectedOption?.label
                                                      ? `-${selectedOption.label}`
                                                      : ""
                                                  }`,
                                                );
                                              }}
                                            />
                                            {formik.touched.dSection &&
                                              formik.errors.dSection && (
                                                <TextError
                                                  msg={formik.errors.dSection}
                                                />
                                              )}
                                          </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={4}>
                                          <MDBox style={{ width: "370px" }}>
                                            <MDTypography
                                              variant="h6"
                                              style={{
                                                fontWeight: "500",
                                              }}
                                            >
                                              Level 3:-
                                              {data.length > 0
                                                ? data[2].rltName
                                                : "No data available"}
                                            </MDTypography>
                                            <Select
                                              isClearable
                                              isDisabled={
                                                ((levelOptions[0]?.value == 2 ||
                                                  levelOptions[1]?.value ==
                                                    2) &&
                                                !dSectionSelected
                                                  ? true
                                                  : false) ||
                                                !(
                                                  levelOptions[0]?.value ===
                                                    3 ||
                                                  levelOptions[1]?.value ===
                                                    3 ||
                                                  levelOptions[2]?.value === 3
                                                )
                                              }
                                              menuPlacement="top"
                                              menuPosition="absolute"
                                              className="select-css"
                                              maxMenuHeight={350}
                                              placeholder="Choose One..."
                                              name="dRack"
                                              onBlur={() => {
                                                formik.handleBlur({
                                                  target: {
                                                    name: "dRack",
                                                  },
                                                });
                                              }}
                                              value={dRackSelected}
                                              options={level3Options}
                                              onChange={(selectedOption) => {
                                                handleDrackChange(
                                                  selectedOption,
                                                );

                                                // Ensure all required values are defined before calling the API
                                                if (
                                                  dWarehouseSelected?.value &&
                                                  selectedOption?.value &&
                                                  selectedItemCode?.itemId &&
                                                  activityIdSelected?.value &&
                                                  jwtToken
                                                ) {
                                                  // Call the API function if all values are defined
                                                  getLevel4ByLevelForTransferOrder(
                                                    dWarehouseSelected?.value,
                                                    selectedOption?.value,
                                                    selectedItemCode?.itemId,
                                                    activityIdSelected?.value,
                                                    jwtToken,
                                                  );
                                                }

                                                formik.setFieldValue(
                                                  "dRack",
                                                  selectedOption,
                                                );
                                                formik.setFieldValue(
                                                  "destinationLocation",
                                                  `${
                                                    formik.values.dWarehouse
                                                      ? formik.values.dWarehouse
                                                          .label
                                                      : ""
                                                  }${
                                                    formik.values.dZone
                                                      ? `-${formik.values.dZone.label}`
                                                      : ""
                                                  }${
                                                    formik.values.dSection
                                                      ? `-${formik.values.dSection.label}`
                                                      : ""
                                                  }${
                                                    selectedOption?.label
                                                      ? `-${selectedOption.label}`
                                                      : ""
                                                  }`,
                                                );
                                              }}
                                            />
                                            {formik.touched.dRack &&
                                              formik.errors.dRack && (
                                                <TextError
                                                  msg={formik.errors.dRack}
                                                />
                                              )}
                                          </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                          <MDBox
                                            mb={1}
                                            ml={1}
                                            style={{ width: "370px" }}
                                          >
                                            <MDTypography
                                              variant="h6"
                                              style={{
                                                fontWeight: "500",
                                              }}
                                            >
                                              {data.length > 0
                                                ? data[3].rltName
                                                : "No data available"}
                                            </MDTypography>
                                            <Select
                                              menuPlacement="top"
                                              menuPosition="absolute"
                                              isClearable
                                              isDisabled={
                                                ((levelOptions[0]?.value == 3 ||
                                                  levelOptions[1]?.value == 3 ||
                                                  levelOptions[2]?.value ==
                                                    3) &&
                                                !dRackSelected
                                                  ? true
                                                  : false) ||
                                                !(
                                                  levelOptions[0]?.value ===
                                                    4 ||
                                                  levelOptions[1]?.value ===
                                                    4 ||
                                                  levelOptions[2]?.value ===
                                                    4 ||
                                                  levelOptions[3]?.value === 4
                                                )
                                              }
                                              className="select-css"
                                              maxMenuHeight={350}
                                              placeholder="Choose one..."
                                              name="dLocation"
                                              onBlur={() => {
                                                formik.handleBlur({
                                                  target: {
                                                    name: "dLocation",
                                                  },
                                                });
                                              }}
                                              value={dLocationSelected}
                                              options={level4Options}
                                              onChange={(selectedOption) => {
                                                handleDlocationChange(
                                                  selectedOption,
                                                );
                                                formik.setFieldValue(
                                                  "dLocation",
                                                  selectedOption,
                                                );
                                                formik.setFieldValue(
                                                  "destinationLocation",
                                                  `${
                                                    formik.values.dWarehouse
                                                      ? formik.values.dWarehouse
                                                          .label
                                                      : ""
                                                  }${
                                                    formik.values.dZone
                                                      ? `-${formik.values.dZone.label}`
                                                      : ""
                                                  }${
                                                    formik.values.dSection
                                                      ? `-${formik.values.dSection.label}`
                                                      : ""
                                                  }${
                                                    formik.values.dRack
                                                      ? `-${formik.values.dRack.label}`
                                                      : ""
                                                  }${
                                                    selectedOption?.label
                                                      ? `-${selectedOption.label}`
                                                      : ""
                                                  }`,
                                                );
                                              }}
                                            />
                                            {formik.touched.dLocation &&
                                              formik.errors.dLocation && (
                                                <TextError
                                                  msg={formik.errors.dLocation}
                                                />
                                              )}
                                          </MDBox>
                                        </Grid>
                                      </Grid>
                                    </MDBox>

                                    <div style={{ background: "white" }}>
                                      <MDButton
                                        style={{
                                          position: "sticky",
                                          bottom: "0",
                                        }}
                                        color="info"
                                        fullWidth
                                        type="submit"
                                        disabled={
                                          // !formik.isValid
                                          //  ||
                                          // !formik.values.asnCode ||

                                          activityIdSelected == "" ||
                                          (levelOptions[0]?.value === 1 &&
                                            !dZoneSelected) ||
                                          (levelOptions[0]?.value === 2 &&
                                            !dSectionSelected) ||
                                          (levelOptions[0]?.value === 3 &&
                                            !dRackSelected) ||
                                          (levelOptions[0]?.value === 4 &&
                                            !dLocationSelected) ||
                                          buttonName === "Please wait..."
                                        }
                                      >
                                        {buttonName}
                                      </MDButton>
                                    </div>
                                    <MDBox>
                                      <Collapse
                                        in={isErrorCreatedTransferOrder}
                                      >
                                        <Alert
                                          severity="error"
                                          action={
                                            <IconButton
                                              aria-label="close"
                                              color="inherit"
                                              size="small"
                                              onClick={() => {
                                                setIsErrorCreatedTransferOrder(
                                                  false,
                                                );
                                              }}
                                            >
                                              <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                          }
                                        >
                                          {errorMsgForCreate}
                                        </Alert>
                                      </Collapse>
                                      <Collapse
                                        in={isSuccessCreatedTransferOrder}
                                      >
                                        <Alert
                                          severity="success"
                                          action={
                                            <IconButton
                                              aria-label="close"
                                              color="inherit"
                                              size="small"
                                              onClick={() => {
                                                setIsSuccessCreatedTransferOrder(
                                                  false,
                                                );
                                              }}
                                            >
                                              <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                          }
                                        >
                                          TransferOrder Created Successfully
                                        </Alert>
                                      </Collapse>
                                    </MDBox>
                                  </div>
                                </Form>
                              );
                            }}
                          </Formik>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    transferOrders: state.transferOrders,
    itemMaster: state.itemMaster,
    getDocumentTypeReducer: state.getDocumentTypeReducer,
    getCreatedActivityReducer: state.getCreatedActivityReducer,
    getSuidsReducer: state.getSuidsReducer,
    getWarehouseByItemCodeAndMovementReducer:
      state.getWarehouseByItemCodeAndMovementReducer,
    getLevel1ByLevelForTransferOrderReducer:
      state.getLevel1ByLevelForTransferOrderReducer,
    getLevel2ByLevelForTransferOrderReducer:
      state.getLevel2ByLevelForTransferOrderReducer,
    getLevel3ByLevelForTransferOrderReducer:
      state.getLevel3ByLevelForTransferOrderReducer,
    getLevel4ByLevelForTransferOrderReducer:
      state.getLevel4ByLevelForTransferOrderReducer,
    availableQtyState: state.getAvailableQtyForToReducer,
    level1ByLevelSrcReducer: state.getLevel1ByLevelSrcReducer,
    level2ByLevelSrcReducer: state.getLevel2ByLevelSrcReducer,
    level3ByLevelSrcReducer: state.getLevel3ByLevelSrcReducer,
    level4ByLevelSrcReducer: state.getLevel4ByLevelSrcReducer,
    getRelationLocationReducer: state.getRelationLocationReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getAllTransferOrdersDownloadReducer:
      state.getAllTransferOrdersDownloadReducer,
    splitQtyReducer: state.splitQtyReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getAllTransferOrders: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getAllTransferOrders(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    getTransferOrderDownloads: (searchObject, jwtToken) =>
      dispatch(getTransferOrderDownloads(searchObject, jwtToken)),
    getSuids: (itemId, activityIdSelected, debouncedSearchTerm, jwtToken) =>
      dispatch(
        getSuids(itemId, activityIdSelected, debouncedSearchTerm, jwtToken),
      ),

    createTransferOrderW2: (payload, jwtToken) =>
      dispatch(createTransferOrderW2(payload, jwtToken)),
    createTransferOrderForQtyW2: (payload, jwtToken) =>
      dispatch(createTransferOrderForQtyW2(payload, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getDocumentType: (jwtToken) => dispatch(getDocumentType(jwtToken)),
    getCreatedActivity: (documentTypeSelected, jwtToken) =>
      dispatch(getCreatedActivity(documentTypeSelected, jwtToken)),
    getWarehousesByItemCodeAndMovement: (
      activityIdSelected,
      itemId,
      jwtToken,
    ) =>
      dispatch(
        getWarehousesByItemCodeAndMovement(
          activityIdSelected,
          itemId,
          jwtToken,
        ),
      ),
    getLevel1ByLevelForTransferOrder: (
      warehouseId,
      parentId,
      itemId,
      acnId,
      jwtToken,
    ) =>
      dispatch(
        getLevel1ByLevelForTransferOrder(
          warehouseId,
          parentId,
          itemId,
          acnId,
          jwtToken,
        ),
      ),
    getLevel2ByLevelForTransferOrder: (
      warehouseId,
      parentId,
      itemId,
      acnId,
      jwtToken,
    ) =>
      dispatch(
        getLevel2ByLevelForTransferOrder(
          warehouseId,
          parentId,
          itemId,
          acnId,
          jwtToken,
        ),
      ),
    getLevel3ByLevelForTransferOrder: (
      warehouseId,
      parentId,
      itemId,
      acnId,
      jwtToken,
    ) =>
      dispatch(
        getLevel3ByLevelForTransferOrder(
          warehouseId,
          parentId,
          itemId,
          acnId,
          jwtToken,
        ),
      ),
    getLevel4ByLevelForTransferOrder: (
      warehouseId,
      parentId,
      itemId,
      acnId,
      jwtToken,
    ) =>
      dispatch(
        getLevel4ByLevelForTransferOrder(
          warehouseId,
          parentId,
          itemId,
          acnId,
          jwtToken,
        ),
      ),
    getAvailableQtyForTo: (itemId, location, jwtToken) =>
      dispatch(getAvailableQtyForTo(itemId, location, jwtToken)),
    getLevel1ByLevelSrc: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevelSrc(warehouseId, parentId, jwtToken)),
    getLevel2ByLevelSrc: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevelSrc(warehouseId, parentId, jwtToken)),
    getLevel3ByLevelSrc: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevelSrc(warehouseId, parentId, jwtToken)),
    getLevel4ByLevelSrc: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevelSrc(warehouseId, parentId, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),

    splitQty: (suid, qty, printerId, jwtToken) =>
      dispatch(splitQty(suid, qty, printerId, jwtToken)),
    reprint: (payload, jwtToken) => dispatch(reprint(payload, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(TransferOrderW2);
